import { render, staticRenderFns } from "./bomPackageScene.vue?vue&type=template&id=248a12fc&scoped=true"
import script from "./bomPackageScene.vue?vue&type=script&lang=js"
export * from "./bomPackageScene.vue?vue&type=script&lang=js"
import style0 from "./bomPackageScene.vue?vue&type=style&index=0&id=248a12fc&prod&lang=css"
import style1 from "./bomPackageScene.vue?vue&type=style&index=1&id=248a12fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a12fc",
  null
  
)

export default component.exports